import { createContext } from "react";
import type { MenuVariantContext } from "./type";

export const MenuContext = createContext<MenuVariantContext>({
  isOpen: false,
});
